import QRCode from 'react-qr-code'
import { getPriceStringWithCurrency } from 'src/mentor/helpers/utilityFunctions'

export default function PaymentLinkQrWithPatientDetails({
  paymentLinkWithPatientDetails,
  resetData,
}) {
  console.log({ paymentLinkWithPatientDetails })

  return (
    <div
      className="px-3"
      style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', width: '100%' }}
    >
      <PatientInfoDetailsViewer patientObject={paymentLinkWithPatientDetails?.currentPatient} />
      {paymentLinkWithPatientDetails?.userPaymentLink?.paymentLink && (
        <QrCodeGeneratorAndViewerViewer
          paymentLink={paymentLinkWithPatientDetails?.userPaymentLink?.paymentLink}
          paymentLinkData={paymentLinkWithPatientDetails?.userPaymentLink}
        />
      )}
    </div>
  )
}

function PatientInfoDetailsViewer({ patientObject }) {
  return (
    <div
      className="d-flex flex-column align-items-start gap-1"
      style={{ textAlign: 'left', fontSize: '20px' }}
    >
      <div className="d-flex justify-content-center">
        <span className="fw-bold" style={{ fontSize: '1.7em', marginBottom: '10px' }}>
          Patient Details
        </span>
      </div>
      <KVItem label="Patient Number" value={patientObject?.patientNumber} />
      <KVItem label="Name" value={patientObject?.name} />
      <KVItem label="Gender" value={patientObject?.gender} />
      <KVItem label="Age" value={patientObject?.age} />
      <KVItem label="Mobile" value={patientObject?.mobile} />
      <KVItem label="Email" value={patientObject?.email} />
      <KVItem label="Address" value={patientObject?.address} />
    </div>
  )
}

function KVItem({ label, value }) {
  return (
    <div style={{ fontSize: '1em' }} className="d-flex justify-content-center">
      <span>
        <strong>{label}: </strong>
        {value || 'NA'}
      </span>
    </div>
  )
}

function QrCodeGeneratorAndViewerViewer({ paymentLink, paymentLinkData }) {
  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-center">
        <QRCode
          value={paymentLink}
          size={256}
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
        />
      </div>
      <div className="d-flex justify-content-center">
        <strong style={{ fontSize: '24px', marginTop: '16px' }}>Scan to pay</strong>
      </div>
      <div className="d-flex justify-content-center">
        <span>
          <strong style={{ fontSize: '24px', marginTop: '16px' }}>Fee: </strong>
          <span style={{ fontSize: '24px', marginTop: '16px' }}>
            {getPriceStringWithCurrency(paymentLinkData?.amount, paymentLinkData?.currency)}
          </span>
        </span>
      </div>
    </div>
  )
}
